import { render, staticRenderFns } from "./client.vue?vue&type=template&id=7238b94f&scoped=true"
import script from "./client.vue?vue&type=script&lang=js"
export * from "./client.vue?vue&type=script&lang=js"
import style0 from "./client.vue?vue&type=style&index=0&id=7238b94f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7238b94f",
  null
  
)

export default component.exports